import { verdictMeta, type Verdict } from "@/mocks/types";

const order: Verdict[] = ["confirmed", "partial", "refuted", "unverified", "developing"];

const ranges: Record<Verdict, string> = {
  confirmed: "85–100 分",
  partial: "55–84 分",
  refuted: "70–100 分 · 结论为否定",
  unverified: "0–54 分",
  developing: "随证据浮动",
};

export default function RatingScale() {
  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
      {order.map((key) => {
        const meta = verdictMeta[key];
        return (
          <div key={key} className="flex flex-col rounded-lg border border-background-200 bg-background-50 p-5">
            <div className="flex items-center justify-between">
              <span className={`inline-flex items-center gap-1 rounded-md px-2.5 py-1 text-xs font-medium ${meta.tone}`}>
                <i className="ri-shield-check-line text-[13px]" aria-hidden="true"></i>
                {meta.label}
              </span>
              <span className="font-label text-[11px] text-foreground-500">{ranges[key]}</span>
            </div>
            <p className="mt-4 text-[13px] leading-relaxed text-foreground-600">{meta.desc}</p>
          </div>
        );
      })}

      <div className="flex flex-col justify-center rounded-lg border border-dashed border-accent-400 bg-accent-50 p-5">
        <p className="font-heading text-base font-bold text-accent-900">评分不是投票</p>
        <p className="mt-2 text-[13px] leading-relaxed text-accent-800">
          可信度由来源数量、材料类型、可复核程度、是否互相矛盾四项加权得出，与热度、传播量无关。
        </p>
      </div>
    </div>
  );
}